import type { FC } from 'react'

import type { Recipe } from '@segment/api/types/recipe'

import Card from '../Card'
import CardsGroup from '../CardsGroup'
import CardsSection from '../CardsSection'

interface FeaturedRecipesProps {
  recipes: Recipe[]
}

const FeaturedRecipes: FC<FeaturedRecipesProps> = ({ recipes }) => {
  return (
    <CardsSection title="Featured recipes">
      <CardsGroup>
        {recipes.map(({ authors, industries, title, description, slug }) => (
          <Card
            key={title}
            authors={authors}
            industries={industries}
            title={title}
            description={description}
            slug={slug}
          />
        ))}
      </CardsGroup>
    </CardsSection>
  )
}

export default FeaturedRecipes
